import { Box, Button, Card, CardContent, Grid, TextField, Typography } from '@mui/material';
import { PageTitle } from 'components';
import { SaveIcon } from 'components/Layout/MainLayout/Sidebar/icons/SaveIcon';
import React, { useEffect, useState } from 'react';
import { useIntl } from "react-intl";
import { toast } from 'react-toastify';
import { useGenerateApiKeyMutation, useGetCompanyApiKeyQuery, useRevokeApiKeyMutation } from 'redux/api/companyApi';
import styles from "scss/Page.module.scss";

const ApiKeyPage: React.FC = () => {
    const { formatMessage } = useIntl();
    const [apiKey, setApiKey] = useState<string | null>(null);
  
    const {data: companyApiKey, isLoading: isCompanyApiKey} = useGetCompanyApiKeyQuery();
    const [requestApiKey, { isSuccess: isGenerateApiKeySuccess, isError: isGenerateApiKeyError, data: apiKeyData }] = useGenerateApiKeyMutation();
    const [revokeApiKey, { isLoading, isSuccess, isError }] = useRevokeApiKeyMutation();


    useEffect(() => {
        if (companyApiKey) {
            setApiKey(companyApiKey.token);
        }
    }
    , [companyApiKey]);
    useEffect(() => {
        if (isGenerateApiKeySuccess && apiKeyData) {
            setApiKey(apiKeyData.token);
        }
    }, [isGenerateApiKeySuccess, apiKeyData]);
    
    const onRequestApiKeyHandler = () => {
      const nifValue = companyApiKey?.company
      if (typeof nifValue === 'string') {
        requestApiKey({ companyId: nifValue });
      }
    }
    
    const handleRevoke = async () => {
      try {
        const cifValue = companyApiKey?.company
        const response = await revokeApiKey({ companyId: cifValue ?? '' }).unwrap();
        toast.success(response.message);
        setApiKey(null); // Clear the API key from state
      } catch (error) {
        toast.error("Failed to revoke token");
      }
    };
    return (
      <Grid container className={styles.viewContainer}>
        <PageTitle
                  pageTitle={formatMessage({ id: "company.key" })}
                />
        <Card
        sx={{
          width: '100%'
        }}>
          <CardContent className={styles.cardContent}>
            <Box>
                <TextField
                    label="API Key"
                    value={apiKey || ''}
                    onChange={(e) => setApiKey(e.target.value)}
                    
                    fullWidth
                    margin="normal"
                    InputProps={{
                        readOnly: true,
                    }}
                    helperText={formatMessage({ id: "company.key.explain" })}
                />
                <Box display="flex" gap={2} justifyContent="flex-start" mt={2}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={onRequestApiKeyHandler}
                    startIcon={<SaveIcon />}
                  >
                    {formatMessage({ id: "company.generate.key" })}
                  </Button>

                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleRevoke}
                    disabled={!apiKey || isLoading}
                    startIcon={<SaveIcon />}
                  >
                    {formatMessage({ id: "company.revoke.key" })}
                  </Button>
                </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    );
};

export default ApiKeyPage;